import { render, staticRenderFns } from "./FreshChatSchedulePopup.vue?vue&type=template&id=3f72e56f&scoped=true"
import script from "./FreshChatSchedulePopup.vue?vue&type=script&lang=js"
export * from "./FreshChatSchedulePopup.vue?vue&type=script&lang=js"
import style0 from "./FreshChatSchedulePopup.vue?vue&type=style&index=0&id=3f72e56f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72e56f",
  null
  
)

export default component.exports